import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import NewLandingPage from './Components/NewLandingPage'
import Wellness from './Components/Wellness'
import Membership from './Components/Membership'
import Community from './Components/Community'
import GiveBack from './Components/GiveBack'
import SignIn from './TeslaBirdPages/SignIn'
import DonateForm from './Components/DonateForm'
import Home from './TeslaBirdPages/Home'
import MentalWellbeing from './TeslaBirdPages/MentalWellbeing'
import Course from './TeslaBirdPages/Course'
import ChapterDetails from './TeslaBirdPages/ChapterDetails'
import Partners from './TeslaBirdPages/Partners'
import Assessments from './TeslaBirdPages/Assessments'
import AiTherapist from './TeslaBirdPages/AiTherapist'
import Podcasts from './TeslaBirdPages/Podcasts'
import PodcastPlayer from './TeslaBirdPages/PodcastPlayer'
import EnquiryForm from './Components/EnquiryForm'
import PaymentForm from './TeslaBirdPages/PaymentForm'
import WellnessKit from './TeslaBirdPages/WellnessKit'
import AssessmentOne from './TeslaBirdPages/AssessmentOne'
import AssessmentTwo from './TeslaBirdPages/AssessmentTwo'
import ConfirmationForm from './TeslaBirdPages/ConfirmationForm'
import ScrollToTop from './Components/ScrollToTop'
import Policy from './Components/Policy'
import ContactUs from './Components/ContactUs'
import PaymentFormNew from './TeslaBirdPages/PaymentFormNew'
import PrivateRoute from './TeslaBirdPages/PrivateRoute'
import ResultOne from './TeslaBirdPages/ResultOne'
import ResultTwo from './TeslaBirdPages/ResultTwo'
import ShippingPolicy from './Components/ShippingPolicy'
import TermsAndConditions from './Components/TermsAndConditions'
import CancelllationAndRefund from './Components/CancelllationAndRefund'
import PrivacyPolicy from './Components/PrivacyPolicy'

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<NewLandingPage />} />
          <Route path='/Wellness' element={<Wellness />} />
          <Route path='/membership' element={<Membership />} />
          <Route path='/community-medicine' element={<Community />} />
          <Route path='/give-back' element={<GiveBack />} />
          <Route path='/policy' element={<Policy />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/shipping-policy' element={<ShippingPolicy />} />
          <Route path='/terms-conditions' element={<TermsAndConditions />} />
          <Route
            path='/cancellations-refunds'
            element={<CancelllationAndRefund />}
          />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/donate-form' element={<DonateForm />} />
          <Route path='/enquiry-form' element={<EnquiryForm />} />
          <Route path='/payment-form' element={<PaymentForm />} />
          <Route path='/payment-form-new' element={<PaymentFormNew />} />
          <Route path='/sign-in' element={<SignIn />} />

          <Route
            path='/home'
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path='/mental_and_physical_wellness'
            element={
              <PrivateRoute>
                <MentalWellbeing />
              </PrivateRoute>
            }
          />
          <Route
            path='/course'
            element={
              <PrivateRoute>
                <Course />
              </PrivateRoute>
            }
          />
          <Route
            path='/chapter/:id'
            element={
              <PrivateRoute>
                <ChapterDetails />
              </PrivateRoute>
            }
          />
          <Route
            path='/partners'
            element={
              <PrivateRoute>
                <Partners />
              </PrivateRoute>
            }
          />
          <Route
            path='/assessments'
            element={
              <PrivateRoute>
                <Assessments />
              </PrivateRoute>
            }
          />
          <Route
            path='/assessmentsOne'
            element={
              <PrivateRoute>
                <AssessmentOne />
              </PrivateRoute>
            }
          />
          <Route
            path='/result-one'
            element={
              <PrivateRoute>
                <ResultOne />
              </PrivateRoute>
            }
          />
          <Route
            path='/assessmentsTwo'
            element={
              <PrivateRoute>
                <AssessmentTwo />
              </PrivateRoute>
            }
          />
          <Route
            path='/result-two'
            element={
              <PrivateRoute>
                <ResultTwo />
              </PrivateRoute>
            }
          />
          <Route
            path='/ai-therapist'
            element={
              <PrivateRoute>
                <AiTherapist />
              </PrivateRoute>
            }
          />
          <Route
            path='/podcasts'
            element={
              <PrivateRoute>
                <Podcasts />
              </PrivateRoute>
            }
          />
          <Route
            path='/podcast-details/:id'
            element={
              <PrivateRoute>
                <PodcastPlayer />
              </PrivateRoute>
            }
          />
          <Route
            path='/wellness-kit'
            element={
              <PrivateRoute>
                <WellnessKit />
              </PrivateRoute>
            }
          />
          <Route
            path='/confirmation-form'
            element={
              <PrivateRoute>
                <ConfirmationForm />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </>
  )
}

export default App
